import { NgClass } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { LazyLoadDirective } from '@bn/web-ui';
import { LoadingComponent } from '@bn/web-ui/loading/loading.component';
import { SensitivityLevelTemplate } from './models';

@Component({
  selector: 'app-app-shield-sensitivity-picker',
  templateUrl: './app-shield-sensitivity-picker.component.html',
  styleUrls: ['./app-shield-sensitivity-picker.component.scss'],
  imports: [LoadingComponent, LazyLoadDirective, NgClass],
})
export class AppShieldSensitivityPickerComponent {
  @Input()
  public items?: SensitivityLevelTemplate[] = [];

  @Input()
  public activeItem?: number = 0;

  @Input()
  public isLoading? = false;

  public readonly itemClick = output<{
    index: number;
    item: SensitivityLevelTemplate;
  }>();
}
